// removed by extract-text-webpack-plugin
module.exports = {"content-wrapper":"app-components-ItemHasRecipe-__ItemHasRecipe___1MQQB","text-has-recipe":"app-components-ItemHasRecipe-__ItemHasRecipe___2KDtL","text-manage":"app-components-ItemHasRecipe-__ItemHasRecipe___v1zD6","recipe-icon":"app-components-ItemHasRecipe-__ItemHasRecipe___dPcsK"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ItemHasRecipe/ItemHasRecipe.css
// module id = 2202
// module chunks = 0